import React, { useState } from "react";

const PhotoItem = ({ photo, onDelete }) => {
    const [loaded, setLoaded] = useState(false);

    const photoWrapperStyle = {
        position: "relative",
        width: "120px",
        height: "120px",
    };

    const photoItemStyle = {
        width: "120px",
        height: "120px",
        borderRadius: "8px",
        objectFit: "cover",
    };

    const deletePhotoBtn = {
        position: "absolute",
        top: "-6px",
        right: "-6px",
        background: "red",
        border: "none",
        color: "white",
        borderRadius: "50%",
        width: "22px",
        height: "22px",
        cursor: "pointer",
    };

    return (
        <div style={photoWrapperStyle}>
            <img
                src={photo.url}
                alt="rea"
                style={{ ...photoItemStyle, display: loaded ? "block" : "none" }}
                onLoad={() => setLoaded(true)}
            />
            {!loaded && <div style={{ ...photoItemStyle, background: "#eee" }}>Chargement…</div>}
            {
                onDelete && (
                    <button onClick={onDelete} style={deletePhotoBtn}>
                        ✖
                    </button>
                )
            }

        </div>
    );
};

export default PhotoItem;
